import { ArticleResolution, ArticleType } from '@wix/answers-api';

import { HelpCenterArticle, HelpCenterVoteableArticle } from '../types';

export const isArticleResolved = (article: HelpCenterArticle): boolean =>
  article.resolution === ArticleResolution.RESOLVED ||
  article.resolution === ArticleResolution.RELEASED;

export const isArticleVoteable = (
  article: HelpCenterArticle,
): article is HelpCenterVoteableArticle => {
  return (
    (article.type === ArticleType.FEATURE_REQUEST ||
      article.type === ArticleType.KNOWN_ISSUE) &&
    !isArticleResolved(article)
  );
};
